
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saa/consume/survey",
      function () {
        return require("private-next-pages/saa/consume/survey/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saa/consume/survey"])
      });
    }
  